
    document.addEventListener("DOMContentLoaded", function () {
      // Select all <li> elements with the class 'wt-product__features__item'
      const listItems = document.querySelectorAll(".wt-product__features__list .wt-product__features__item");

      listItems.forEach((item) => {
        // Get the text content of the <li>
        const text = item.textContent.trim();

        // Extract the first word
        const firstWord = text.split(" ")[0].replace(":", ""); // Remove ":" if it exists

        // Generate a class name based on the first word
        const dynamicClass = `icon-${firstWord.toLowerCase()}`;

        // Add the dynamic class to the <li>
        item.classList.add(dynamicClass);
      });
    });
